var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filebox"},[_c('input',{ref:"file",staticClass:"upload-hidden",attrs:{"id":"file","type":"file","accept":_vm.accept,"multiple":""},on:{"change":_vm.onSelectFile}}),_c('label',{staticClass:"file-upload-btn btn",class:_vm.btnStyle,attrs:{"for":"file"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }